/* Reuse the native Shopify drawer and freshly rendered server cart markup. */
(() => {
  if (window.vqEditorialBagReady) return;
  window.vqEditorialBagReady = true;
  let opening;
  const root = window.Shopify?.routes?.root || '/';
  async function openBag(trigger) {
    if (opening) return opening;
    const wrapper = document.getElementById('shopify-section-cart-drawer-section');
    if (!wrapper) return;
    opening = (async () => {
      trigger?.setAttribute('aria-busy', 'true');
      await window.VessariqCartNavigation?.wait();
      try {
        const url = new URL(root, location.origin);
        url.searchParams.set('section_id', 'cart-drawer-section');
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Cart unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = html.getElementById('shopify-section-cart-drawer-section');
        if (!next?.querySelector('theme-drawer')) throw new Error('Missing cart');
        wrapper.replaceWith(next);
        await customElements.whenDefined('theme-drawer');
        document.getElementById('cart-drawer').open();
      } catch {
        location.assign(`${root}cart`);
      } finally {
        trigger?.removeAttribute('aria-busy');
      }
    })();
    try { await opening; } finally { opening = null; }
  }
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const trigger = event.target.closest('[data-vq-cart-link]');
    if (!trigger || !document.getElementById('cart-drawer')) return;
    event.preventDefault();
    openBag(trigger);
  });
  document.addEventListener('vq:cart-updated', () => {
    if (document.getElementById('cart-drawer')) openBag(document.querySelector('[data-vq-cart-link]'));
  });
})();
